import { api } from '../../lib/api';

export const usersApi = {
  // Users
  listUsers: () => api.get('/users'),
  updateUser: (id, payload) => api.putWithId(`/users/${id}`, id, payload),
  activateUser: (id) => api.post(`/users/${id}/activate`),
  deactivateUser: (id) => api.post(`/users/${id}/deactivate`),
  sendPasswordReset: (id) => api.post(`/users/${id}/send-password-reset`),
  deleteUser: (id) => api.del(`/users/${id}`),

  // Roles
  listRoles: () => api.get('/roles'),
  permissionCatalog: () => api.get('/roles/permissions'),
  createRole: (payload) => api.post('/roles', payload),
  updateRole: (id, payload) => api.putWithId(`/roles/${id}`, id, payload),
  deleteRole: (id) => api.del(`/roles/${id}`),

  // Invitations
  listInvites: () => api.get('/invites'),
  invite: (payload) => api.post('/invites', payload),
  resendInvite: (id) => api.post(`/invites/${id}/resend`),
  revokeInvite: (id) => api.post(`/invites/${id}/revoke`),
};

// Public (no auth) endpoints used by the accept-invite page.
export const publicInvitesApi = {
  preview: (token) => api.get(`/public/invites?token=${encodeURIComponent(token)}`, { auth: false }),
  accept: (payload) => api.post('/public/invites/accept', payload, { auth: false }),
};
